<template>
  <d2-container>
    <div class="platform">
      <div class="platformbanner">
        <div class="platformbasecont">
          <h3>云智共生，定义未来</h3>
          <div style="height: 24px;" />
          <h4>面向人工智能的先进云计算技术，打开智慧业务新时代</h4>
        </div>
      </div>

      <div class="platformbasecont">
        <div class="platformbaseconttitle">AI+算力技术</div>
        <div class="platformSection1 pgf">
          <p>云计算时代有云原生的概念，在人工智能时代，尤其是大模型的涌现能力出现了之后，将来一定有“算力原生”，或者说叫“AI原生”的概念和技术体系。</p>
          <p>“+AI”或者说AI赋能的概念是在一个传统的系统中的一部分功能使用一些AI的能力，比如说在一些设备的人机交互界面增加语音交互的能力，比如通过人脸识别进行身份验证，这些都是很典型也很普遍的+AI的应用场景。在这些场景中，很多时候之前的小模型已经取得了不错的效果，不需要大模型。</p>
          <p>未来的AI原生应用将基于AI技术和算力，以知识的生产和输出作为目标，重构业务流程和系统架构，以更高效的利用算力产生价值。</p>
        </div>
      </div>

      <div class="platformbasecontTwo top-240">
        <div class="platformbasecontTwopoab" >
          <div class="platformbasecont" >
            <div class="platformflex  platformflex1">
              <img src="/image/portalimg/tech/platformflexTwo.png">
            </div>
          </div>
        </div>
      </div>

      <div class="platformSection2"></div>

      <div class="platformbasecont">
        <div class="platformbaseconttitle">面向AI的算力加速与优化技术</div>
        <div class="platformSection1 pgf" >
          <p>我们的云平台还内置了计算加速引擎，可以在英伟达、华为及其他国产AI芯片上实现计算加速。</p>
          <p>平台内置的计算加速引擎，相比于知名开源项目 ComfyUI，可大幅提示推理速度。
            无需引入不引入模型量化、裁剪、蒸馏等改变模型表现的操作就能够为用户一并解决系统运行不稳定或显存不足导致的系统崩溃问题。</p>
        </div>
      </div>

       <div class="platformbasecontTwo" style="top:-238px">
        <div class="platformbasecontTwopoab" >
          <div class="platformbasecont" >
            <div class="platformflex platformflex2">
<!--            <div class="platformflex" style="width:1369px; height: 364px; margin:0 auto;">-->
              <img src="/image/portalimg/tech/platformflexTwo2.png">
            </div>
          </div>
        </div>
      </div>

      <div class="platformSection2" style="height: 278px;"></div>
      <div class="platformbasecont">
        <div class="platformbaseconttitle">智能运维技术</div>
        <div class="platformSection1 pb-227 pgf">
          基于平台的故障监测、运行指标收集能力，结合故障应急处理专家系统的专家经验库和故障处置知识库，利用大模型的语言处理和推理分析能力，给出故障诊断结论，进行故障处置，并进行故障预测。
        </div>
      </div>

       <div class="platformbasecontTwo top-170">
        <div class="platformbasecontTwopoab">
          <div class="platformbasecont" >
            <div class="platformflex  platformflex3">
              <img src="/image/portalimg/tech/platformflexTwo3.png">
            </div>
          </div>
        </div>
      </div>
      <div class="platformSection2"></div>

      <div class="platformbasecont">
        <div class="platformbaseconttitle">关于智能计算服务水平</div>
        <div class="platformSection1 pb-518">
          <b>全生命周期的支持：</b>人工智能的算力应用，从开始准备数据集、再到模型开发、模型的训练微调、模型的推理服务以及模型的应用，应用阶段可能会涉及到知识库、智能体和提示词工程等内容。算力服务平台需要尽可能多的覆盖到人工智能生命周期各个阶段的功能需求。<br/>
          <b>全服务模式的支持：</b>算力服务的使用模式，对于有完整技术体系的用户来说，他们往往更倾向于以IaaS的模式使用算力，对于不想做底层运维但有一定技术能力的用户来说PaaS模式可能是最合适的，对于做轻量化模型应用的用户来说，MaaS模式是最合适的，而对于终端用户来说，以SaaS形式在具体场景有AI赋能的智能应用才能真正落地。算力服务平台需要能够支持不同的算力使用模式。<br/>
          <b>对能源效率的优化：</b>智算中心需要消耗大量的电力，数据中心整体的PUE需要尽量低，使用的绿电占比得尽量高，才能降低智算中心算力运营的成本，所以能源效率也间接影响到用户使用算力服务的价格。

        </div>
      </div>

       <div class="platformbasecontTwo top-450">
        <div class="platformbasecontTwopoab" >
          <div class="platformbasecont" >
            <div class="platformflex  platformflex4">
              <img src="/image/portalimg/tech/platformflexTwo4.png">
            </div>
          </div>
        </div>
      </div>
      <div class="platformSection2 mb-80"></div>


      <base-bottom></base-bottom>

    </div>
  </d2-container>
</template>

<script>
import baseBottom from '../components/base-bottom'

export default {
  name: 'solutions',
  components: {
    baseBottom
  },
  data() {
    return {

    }
  },
}
</script>

<style scoped>
*,body,html{
  margin: 0;
  padding: 0;
  width: 100%;
}
.lf { float: left;}
.rf{ float: right;}

.pgf {
  text-indent: 2em;
}

@media (min-width: 769px) {
    /* PC端样式 */

.platformbanner{
  background: url("/image/portalimg/tech/banner.png") no-repeat center center;
  height: auto;
}
.platformbasecont{
  width: 1490px;
  margin: 0 auto;
  overflow: hidden;
  letter-spacing: 1.68px;
  line-height: 35px;
  font-weight: 500;
}
.platformbasecont h3{
  font-size: 26px;
  color: #FFFFFF;
  text-align: center;
  font-weight: 400;
  padding-top: 199px;
  padding-bottom: 15px;
}
.platformbasecont .platformbaseconttitle{
  font-size: 32px;
  color: #000000;
  font-weight: 400;
  padding: 100px 0 40px;
  text-align: center;
}
.platformbasecont h4{
  font-size: 32px;
  color: #FFFFFF;
  letter-spacing: 3.2px;
  text-align: center;
  line-height: 51px;
  font-weight: 400;
}
.platformbasecont h4:last-child{
  padding-bottom: 161px;
}

.platformSection1{
  text-align: center;
  font-size: 16px;
  text-align: left;
  line-height: 37px;
  font-weight: 400;
  padding-bottom:293px;
}
.platformSection2,.platformSection4,.platformSection6,.platformSection8{
  background: #F3F7FF;
}
.platformSection2{
  height: 230px;
}
.platformbasecontTwo{
  position: relative;
  background: #F3F7FF;
}
.platformbasecontTwopoab{
  position: absolute;
}
.platformflex{
  margin: 0 auto;
}
.platformflex.platformflex1{
  width:1360px; 
  height: 423px;
}
.platformflex.platformflex2{
  width:1369px; 
  height: 476px;
}
.platformflex.platformflex3{
  width:1061px; 
  height: 357px;
}
.platformflex.platformflex4{
  width:1360px; 
  height: 648px;
}
.top-240{
  top:-240px
}
.top-126{
  top:-126px
}
.top-170{
  top:-170px
}
.top-450{
  top:-450px
}
.platformbasecont .platformbaseconttitle.f-24{
  font-size: 24px;
}
.pb-185{
  padding-bottom: 185px;
}

.pb-227{
  padding-bottom:227px;
}
.pb-518{
  padding-bottom:518px;
}
.mb-80{
  margin-bottom: 80px;
}
b{
  color: #000;
}

}
@media (max-width: 768px) {
    /* 移动端样式 */

.platformbanner{
    background: url("/image/portalimg/tech/banner.png") no-repeat center center;
    height: auto;
    background-size: 100% 100%;
}
.platformbasecont{
  width: 100%;
  overflow: hidden;
  letter-spacing: 1px;
  line-height: 35px;
  font-weight: 500;
  padding-bottom: 20px;
}
.platformbasecont h3{
  font-size: 18px;
  color: #FFFFFF;
  text-align: center;
  font-weight: 400;
  padding-top: 100px;
}
.platformbasecont .platformbaseconttitle{
  font-size: 18px;
  color: #000000;
  font-weight: 400;
  padding: 30px 0 10px;
  text-align: center;
}
.platformbasecont h4{
  width: 75%;
  margin: 0 15%;
  font-size: 14px;
  color: #FFFFFF;
  letter-spacing: 3px;
  text-align: center;
  line-height: 28px;
  font-weight: 400;
}
.platformbasecont h4:last-child{
  padding-bottom: 10px;
  margin-top: -18px;
}

.platformSection1{
  width: 95%;
  margin: 0 2%;
  text-align: center;
  font-size: 14px;
  text-align: left;
  line-height: 30px;
  font-weight: 400;
  padding-bottom:10px;
}
.platformSection2,.platformSection4,.platformSection6,.platformSection8{
  display: none;
  background: #F3F7FF;
}
.platformSection2{
  height: 230px;
}
.platformbasecontTwo{
  background: #fff;
}
.platformbasecontTwopoab{
  position: static;
}
.platformflex{
  width: 95%;
  margin: 0 auto;
}
.top-240{
  top:0;
}
.top-126{
  top:-126px
}
.top-170{
  top:-170px
}
.top-450{
  top:-450px
}
.platformbasecont .platformbaseconttitle.f-24{
  font-size: 24px;
}

b{
  color: #000;
}
.platformSection2,.platformSection4,.platformSection6,.platformSection8{
  display: none;
}

}
</style>

